var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"className":"demo"}},[_c('div',{staticStyle:{"width":"600px"},attrs:{"id":"video-container"}})])
}]

export { render, staticRenderFns }